import React, { memo, forwardRef } from 'react';
import { AuthPageContainerPhoneTemplate } from '@redlink/components/templates';

export const AuthPageContainer = memo(
  forwardRef(({ isBusy, children, withGoogleAuth, title }, ref) => {

    return (
      <AuthPageContainerPhoneTemplate
        {...{ isBusy, ref, withGoogleAuth, title }}
      >
        {children}
      </AuthPageContainerPhoneTemplate>
    );
  })
);
